import { render, staticRenderFns } from "./FooterComponentDash.vue?vue&type=template&id=076c9382&scoped=true"
import script from "./FooterComponentDash.vue?vue&type=script&lang=js"
export * from "./FooterComponentDash.vue?vue&type=script&lang=js"
import style0 from "./FooterComponentDash.vue?vue&type=style&index=0&id=076c9382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c9382",
  null
  
)

export default component.exports